query GetAudienceMembers(
  $audienceId: ID!
  $firstNMembers: Int
  $membersAfterCursor: String
  $lastNMembers: Int
  $membersBeforeCursor: String
  $search: String
  $sort: MembersSorting,
  $filters: [MembersFilter]
) {
  audience(audienceId: $audienceId) {
    members(
      first: $firstNMembers
      after: $membersAfterCursor
      last: $lastNMembers
      before: $membersBeforeCursor
      search: $search
      sort: $sort
      filters: $filters
    ) {
      nodes {
        alternativeEmails
        customFields {
          id
          selectedOptions
        }
        email
        fields {
          company
          firstName
          fullName
          lastName
          linkedin
          role
          url
        }
        flagged {
          isBounced
          isUnsubscribed
          unsubscribedUntil
        }
        id
        remoteId
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
}
